import axios from "axios";
import { api } from "./api_route";

//Case Primary Information Routes --> Asset Details (Other Assets)

// =========== GET ALL ASSETS BY CASE ID ===========
export const getAllAssetsByCaseId = async (caseDetailsID) => {
    try {
        const response = await axios.get(
            `${api}/case/caseOtherDetails/all/${caseDetailsID}`
        );

        return {
            success: true,
            data: response.data.data || [],
            parties: response.data.parties || [],
            count: response.data.count || 0,
            message: response.data.message || "Assests fetched successfully",
        };
    } catch (error) {
        console.error("Error fetching assets:", error);
        return {
            success: false,
            data: [],
            count: 0,
            message: error.response?.data?.message || "Failed to fetch assets",
            error: error.response?.data?.error || error.message,
        };
    }
};

// =========== GET SINGLE ASSET BY ID ===========
export const getAssetById = async (id) => {
    try {
        const response = await axios.get(
            `${api}/case/caseOtherDetails/${id}`
        );

        return {
            success: true,
            data: response.data.data,
            message: response.data.message || "Asset fetched successfully",
        };
    } catch (error) {
        console.error("Error fetching asset:", error);
        return {
            success: false,
            data: null,
            message: error.response?.data?.message || "Failed to fetch asset",
            error: error.response?.data?.error || error.message,
        };
    }
};

// =========== CREATE NEW ASSET ===========
export const createAsset = async (assetData) => {
    try {
        const response = await axios.post(
            `${api}/case/caseOtherDetails`,
            assetData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        return {
            success: true,
            data: response.data.data,
            message: response.data.message || "Asset created successfully",
        };
    } catch (error) {
        console.error("Error creating asset:", error);
        return {
            success: false,
            data: null,
            message: error.response?.data?.message || "Failed to create asset",
            error: error.response?.data?.error || error.message,
        };
    }
};

// =========== UPDATE ASSET ===========
export const updateAsset = async (id, assetData) => {
    try {
        const response = await axios.put(
            `${api}/case/caseOtherDetails/${id}`,
            assetData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        return {
            success: true,
            data: response.data.data,
            message: response.data.message || "Asset updated successfully",
        };
    } catch (error) {
        console.error("Error updating asset:", error);
        return {
            success: false,
            data: null,
            message: error.response?.data?.message || "Failed to update asset",
            error: error.response?.data?.error || error.message,
        };
    }
};

// =========== DELETE ASSET ===========
export const deleteAsset = async (id, updatedBy) => {
    try {
        const response = await axios.delete(
            `${api}/case/caseOtherDetails/${id}`,
            { data: { updatedBy } }
        );

        return {
            success: true,
            message: response.data.message || "Asset deleted successfully",
        };
    } catch (error) {
        console.error("Error deleting asset:", error);
        return {
            success: false,
            message: error.response?.data?.message || "Failed to delete asset",
            error: error.response?.data?.error || error.message,
        };
    }
};

// =========== SEARCH ASSETS ===========
export const searchAssets = async (caseDetailsID, searchCriteria) => {
    try {
        const response = await axios.post(
            `${api}/case/caseOtherDetails/search/${caseDetailsID}`,
            searchCriteria
        );

        return {
            success: true,
            data: response.data.data || [],
            count: response.data.count || 0,
            message: response.data.message || "Search completed successfully",
        };
    } catch (error) {
        console.error("Error searching assets:", error);
        return {
            success: false,
            data: [],
            count: 0,
            message: error.response?.data?.message || "Failed to search assets",
            error: error.response?.data?.error || error.message,
        };
    }
};

// =========== HELPER FUNCTIONS ===========

export const formatAssetData = (data) => {
    const formatted = { ...data };

    // Handle date formatting if needed
    const formatDate = (date) => {
        if (!date) return null;
        if (date instanceof Date) {
            return date.toISOString().split("T")[0];
        }
        return date;
    };

    formatted.securityCreationDate = formatDate(formatted.securityCreationDate);

    return formatted;
};

export const parseAttachmentIds = (attachmentField) => {
    if (!attachmentField) {
        return [];
    }
    if (Array.isArray(attachmentField)) {
        return attachmentField;
    }
    if (typeof attachmentField !== 'string') {
        return [];
    }
    if (attachmentField.trim() === "") {
        return [];
    }
    return attachmentField
        .split(",")
        .map((id) => id.trim())
        .filter((id) => id !== "");
};

export const otherAssetFilesDownload = async (values) => {
    try {
        const response = await axios.get(`${api}/documents/asset/otherDetails/${values}`, {
            responseType: "blob", // Important for file downloads
        });
        return response.data;
    } catch (error) {
        return null;
    }
};
